function modelElementsInit() {
  let modelHeadElements = document.querySelectorAll("[data-model-main-head]");
  let modelConetntBody = document.querySelectorAll("[data-model-main-body]");
  Array.from(modelHeadElements).forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.preventDefault();
      let dataId = element.getAttribute("data-id");
      Array.from(modelConetntBody).forEach(function (bodyElement) {
        bodyElement.classList.remove("active");
      });
      if (element.classList.contains("search")) {
        document.querySelector("body").classList.add("search-open");
        focusElement = element;
        trapFocusElements(
          document.querySelector(".predictive-search-container"),
        );
        setTimeout(() => {
          document
            .querySelector("#Search-In-Template")
            .setAttribute("tabindex", "0");
          document.querySelector("#Search-In-Template").focus();
        }, 100);
      }
      document.querySelector("body").classList.add("no-scroll");
      const mainslector = document.querySelector("#" + dataId);
      mainslector.classList.add("active");
      focusElement = element;

      if (dataId == "product-media-popup") {
        trapFocusElements(mainslector.querySelector(".product-gallery-inner"));
        if (mainslector.querySelector("[data-flickity]")) {
          let index = element.getAttribute("data-index");
          let slider = Flickity.data(
            mainslector.querySelector("[data-flickity].flickity-enabled"),
          );
          themeSlidersInit($(".paroduct-thumbnail-gallery"));
          slider.resize();
          slider.select(index);
          if (window.ProductModel) window.ProductModel.loadShopifyXR();
        }
      } else {
        trapFocusElements(mainslector);
      }
    });
  });
  let modelCloseElements = document.querySelectorAll("[data-model-close]");
  Array.from(modelCloseElements).forEach(function (closeElement) {
    closeElement.addEventListener("click", function (event) {
      event.preventDefault();
      document.querySelector("body").classList.remove("no-scroll");
      if (document.querySelector("body").classList.contains("search-open")) {
        document.querySelector("body").classList.remove("search-open");
      }

      closeElement.closest("[data-model-main-body]").classList.remove("active");
      if (document.querySelector("[data-predictive-search]")) {
        document.querySelector("[data-predictive-search]").innerHTML = "";
      }
      focusElement = "";
      removeTrapFocus();
    });
  });
}
document.addEventListener("DOMContentLoaded", function (section = document) {
  modelElementsInit();
});

document.addEventListener("shopify:section:load", function (section) {
  let sectiontarget = section.target;
  modelElementsInit(sectiontarget);
});

/* PETG USA: tap/click on main product image opens the existing lightbox.
   Ignores taps that were really swipes/drags (>10px movement). */
(function () {
  if (window.__petgImageTapZoom) return;
  window.__petgImageTapZoom = true;
  var startX = 0, startY = 0, moved = false;
  document.addEventListener("pointerdown", function (e) {
    startX = e.clientX; startY = e.clientY; moved = false;
  }, { passive: true });
  document.addEventListener("pointermove", function (e) {
    if (Math.abs(e.clientX - startX) > 10 || Math.abs(e.clientY - startY) > 10) moved = true;
  }, { passive: true });
  document.addEventListener("click", function (e) {
    if (moved) return;
    if (e.target.closest(".product-media-popup-btn, a, button, video, model-viewer")) return;
    var item = e.target.closest(".main-product-slider [data-media-popup]");
    if (!item) return;
    var slider = item.closest(".flickity-enabled");
    if (slider && window.Flickity) {
      var f = Flickity.data(slider);
      if (f && f.isDragging) return;
    }
    var btn = item.querySelector(".product-media-popup-btn");
    if (btn) { e.preventDefault(); btn.click(); }
  });
  var s = document.createElement("style");
  s.textContent = ".main-product-slider [data-media-popup] .media-image{cursor:zoom-in}";
  document.head.appendChild(s);
})();
